import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

interface AiSummaryCardProps {
  token: string;
  type?: string;
  inline?: boolean;
}

export const AiSummaryCard = ({
  token,
  type,
  inline = false,
}: AiSummaryCardProps) => {
  const queryParams = new URLSearchParams();

  if (type) {
    queryParams.set('type', type);
  }

  if (inline) {
    queryParams.set('inline', 'true');
  }

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeHeight, setIframeHeight] = useState<number>(inline ? 80 : 300);

  const onMessage = useCallback(({ data: message, origin, source }) => {
    if (source !== iframeRef.current?.contentWindow) {
      return;
    }

    if (origin !== window.location.origin) {
      return;
    }

    if (message?.source !== 'embedded-dashboard') {
      return;
    }

    switch (message.type) {
      case 'resize':
        setIframeHeight(message.data.height);
        break;
      default:
        break;
    }
  }, [setIframeHeight]);

  useEffect(() => {
    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, [onMessage]);

  return (
    <iframe
      ref={iframeRef}
      width="100%"
      height={iframeHeight}
      style={{ border: 'none' }}
      src={`${window.origin}/embedded/summary/${token}?${queryParams.toString()}`}
    />
  );
};
